import React, { FunctionComponent } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Compound, Substance } from '../../shared/models/Substance';
import { useTranslation } from 'react-i18next';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { AppBar, Toolbar } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import {
    Transition,
    useStyles,
    SubstanceContainer,
} from '../SubstanceModal/SubstanceModal';

interface LabelWithInfoParams {
    label: string;
    info: string;
}

function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

interface CompoundModalParams {
    compound: Compound;
}

export const CompoundModal: FunctionComponent<CompoundModalParams> = ({
    compound,
}) => {
    const [t] = useTranslation();

    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [snackbarState, setSnackbarState] = React.useState(false);

    const handleCopyClick = () => {
        setSnackbarState(true);
    };

    const handleCopyClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarState(false);
    };

    return (
        <div>
            <Button
                color="primary"
                onClick={handleClickOpen}
                variant="contained"
            >
                {t('Select')}
            </Button>
            <Dialog
                // fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
                fullWidth
                classes={{
                    paperWidthSm: classes.paperWidthSm,
                }}
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <Typography variant="h6" className={classes.title}>
                            {compound.name}
                        </Typography>
                        <Button autoFocus color="inherit" onClick={handleClose}>
                            {t('Close')}
                        </Button>
                    </Toolbar>
                </AppBar>
                <Typography variant="h3">
                    <Box m={3} mb={0}>
                        {t('Composition of the compound')} {compound.name} (
                        {compound.components.length}):
                    </Box>
                </Typography>
                {compound.components.map((component: Substance) => {
                    return (
                        <SubstanceContainer
                            key={compound.id + compound.name + component.id}
                            substance={component}
                            onClick={handleCopyClick}
                        />
                    );
                })}
                <Snackbar
                    open={snackbarState}
                    autoHideDuration={700}
                    onClose={handleCopyClose}
                >
                    <Alert
                        className={classes.snackBar}
                        onClose={handleCopyClose}
                        severity="success"
                    >
                        {t('Copied!')}
                    </Alert>
                </Snackbar>
            </Dialog>
        </div>
    );
};
